import { AnyCardVisualization, CardLineVisualization } from '../../../api/v2';

export function isLineVisualization(
    config: AnyCardVisualization
): config is CardLineVisualization {
    return config.kind === 'line';
}
